import React from "react"
import { Link, useHistory } from "react-router-dom"
import { useRecoilState, useResetRecoilState } from "recoil"
import { useSnackbar } from "notistack"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"

import StepButtons from "../components/StepButtons"
import { createAssociation, fetchDbUser } from "../libs/manageAccounts"
import currentAssociation from "../store/currentAssociation"
import currentUser from "../store/currentUser"
import onboardingProgress from "../store/onboardingProgress"

export default function BillingInfo(props) {
  const [isLoading, setIsLoading] = React.useState(false)
  const [association, setAssociation] = useRecoilState(currentAssociation)
  const [user, setUser] = useRecoilState(currentUser)
  const [progress] = useRecoilState(onboardingProgress)
  const resetProgress = useResetRecoilState(onboardingProgress)
  const history = useHistory()
  const { enqueueSnackbar } = useSnackbar()

  const handleSubmit = async (event) => {
    event.preventDefault()
    setIsLoading(true)
    try {
      const newAssociation = Object.assign({}, progress.association)
      delete newAssociation.addressFull
      delete newAssociation.cardId
      delete newAssociation.image
      delete newAssociation.position
      delete newAssociation.unit
      newAssociation.location = JSON.stringify(newAssociation.location)

      const associationId = await createAssociation(
        newAssociation,
        user ? user : progress.user,
        progress.association.position,
        progress.association.unit
      )

      setAssociation({
        ...association,
        ...newAssociation,
        id: associationId,
      })

      const updatedUser = await fetchDbUser(user.id)
      if (updatedUser) {
        setUser(updatedUser)
      }

      // if (progress.user) {
      //   setUser({
      //     ...user,
      //     ...progress.user,
      //   })
      // }

      resetProgress()
      setIsLoading(false)
      return history.push("/0")
    } catch (error) {
      console.log("error", error)
      enqueueSnackbar(error.message, {
        variant: "error",
      })
      setIsLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography style={{ textDecoration: "line-through" }}>
            Your card will be charged $9.95 /year
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            You are joining the Condo Axis beta program! Your account will be free during the beta
            period. Any changes will be communicated in advance.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            Let us know what you like, anything that is not working for you, and features you would
            like to see in the future.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="button" component="p" mb={20}>
            Drop us a line: <Link to="mailto:beta@hi.condoaxis.com">beta@hi.condoaxis.com</Link>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <StepButtons
            isLoading={isLoading}
            nextText={props.nextText ? props.nextText : "Create Account"}
          />
        </Grid>
      </Grid>
    </form>
  )
}
